<template>
  <a v-if="name"
     class="card-link"
     href="#">
    <article class="author-card">
      <div class="author-image-container">
        <img class="author-image"
             :src="src"
             :alt="alt">
      </div>
      <div class="article-details">
        <p v-if="bio"
           class="author-description">{{ bio }}</p>
        <p class="author-name">{{ name }}</p>
      </div>
    </article>
    <input type="hidden"
           :placeholder="log">
  </a>
</template>

<script>
export default {
  name: "Author",
  props: {
    name: { type: String, default: undefined },
    bio: { type: String, default: undefined },
    src: { type: String, default: "/Assets/images/generic-user.png" },
    alt: { type: String, default: "Author profile picture" }
  },
  computed: {
    log () {
      console.log( this.src === "" );
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.transition(@args...) {
  transition: @args;
}

.author-card {
  display: flex;
  flex-direction: row;
  background: transparent;
  border-radius: 0.375rem;
  overflow: hidden;
}

.card-link {
  position: relative;
  display: block;
  color: inherit;
  text-decoration: none;
}

.card-link:hover .author-image {
  .transition(opacity 0.3s ease);
  opacity: 0.9;
}

.author-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.author-image {
  .transition(opacity 0.3s ease);
  border-radius: 50%;
  display: block;
  width: 125px;
  height: 125x;
  margin: 1em;
  object-fit: cover;
}

.author-image.error {
  display: none;
}

.article-details {
  padding: 1.5rem;
}

.author-name {
  font-size: 0.875rem;
  line-height: 1;
  font-weight: 700;
  margin: 1.125rem 0 0 0;
  padding: 1.125rem 0 0 0;
  border-top: 0.0625rem solid #ebebeb;
}

@media (max-width: 40rem) {
  .author-card {
    flex-wrap: wrap;
  }
}

@supports (display: grid) {
  .author-image-container {
    height: 100%;
  }

  .author-card {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: 1fr;
  }

  @media (max-width: 40rem) {
    .author-card {
      grid-template-columns: auto;
      grid-template-rows: 12rem 1fr;
    }
  }
}
</style>
